import { CommunityEvent, NextShopTalkEventResponse } from '@optimus/models';
import { axiosInstance } from './apiConfig';

/** The member's next core business discussions in the Community (SN-1047). */
export const getUpcomingCommunityEvents = async (memberId: string): Promise<CommunityEvent[]> => {
  const { data } = await axiosInstance.get<CommunityEvent[]>(`/members/${memberId}/community-events`);
  return data;
};

/** The next Shop Talk event in the Community, or `null` when none is scheduled (SN-1047). */
export const getNextShopTalkEvent = async (): Promise<CommunityEvent | null> => {
  const { data } = await axiosInstance.get<NextShopTalkEventResponse>('/community-events/shop-talk/next');
  return data.event;
};
